import { Graphics, Point, SCALE_MODES, WebGLRenderer } from "pixi.js";
import { BoosterRenderer } from "../../../game/Utils/BoosterRenderer";
import { BoosterNameEnum, BoosterTypeEnum, GameModel } from "../../../game/Models/GameModel";
import { ModelEvents, SoundManager } from "@denishussar/html5-game-engine";
import { SoundConstants } from "../../../game/Constants/Sounds";
import { SoundModel } from "../../../game/Models/SoundModel";
import { GameLogic } from "../GameLogic";
import { GameEvent, GameEventBoosterUse } from "../../../game/Constants/GameEvent";

export class ThreadBooster extends BoosterRenderer {
    private x = 0;
    private y = 0;
    constructor(
        private gameModel: GameModel,
        private soundManager: SoundManager,
        private gameLogic: GameLogic,
        private modelEvents: ModelEvents,
        renderer: WebGLRenderer
    ) {
        super(renderer, {
            width: gameModel.saveTexture.width,
            height: gameModel.boosterNeedleSize,
            scaleMode: SCALE_MODES.NEAREST,
            resolution: 1
        });
        this.createFill();
        this.sprite.width = gameModel.saveTexture.width * GameModel.pixelSize;
        this.sprite.height = gameModel.boosterNeedleSize * GameModel.pixelSize;
    }

    private createFill() {
        const zone = new Graphics(true);
        zone.beginFill(0x008800, 0.3);

        let textureX = 0;
        for (let x = 0; x < this.gameModel.saveTexture.width; x++) {
            let textureY = 0;
            for (let y = this.y; y < this.y + this.gameModel.boosterNeedleSize; y++) {
                if (y < this.gameModel.saveTexture.height && y >= 0) {
                    const brush = this.gameModel.paletteColor;
                    const color = this.gameLogic.getPixelColor(x, y);
                    if (brush === color) {
                        zone.drawRect(textureX, textureY, 1, 1);
                    }
                }
                textureY++;
            }
            textureX++;
        }
        zone.endFill();
        this.draw(); // clear render target
        this.draw(zone); // draw zone
        zone.destroy();
    }

    movePointer(x: number, y: number) {
        // this.sprite.x = x * GameModel.pixelSize;
        this.sprite.y = y * GameModel.pixelSize;
        const oldY = this.y;
        this.y = y;
        if (y !== oldY)
            this.createFill();
    }

    private boosterNeedlePoint: Point;
    fill(x: number, y: number): void {
        this.boosterNeedlePoint = new Point(x, y);

        const pixels = this.getBoosterNeedleAllRows();
        if (pixels.length) {
            this.soundManager.play(SoundConstants.BOOSTER_NEEDLE, false, SoundModel.fx);
            this.gameLogic.decBooster(BoosterTypeEnum.needle);

            this.modelEvents.dispatch(this.gameModel, this.gameLogic.isFTUE ? GameEvent.tutorialBoosterUse : GameEvent.boosterUse, <GameEventBoosterUse>{
                boosterName: BoosterNameEnum.needle,
                levelName: this.gameModel.picture.name,
                levelSize: this.gameModel.currentPictureWidth,
            });
        }

        this.gameLogic.disableBoosters();

    }

    private getBoosterNeedleAllRows(isGreed = false): Point[] {
        const rows = this.gameModel.boosterNeedleSize;
        const pixels: Point[] = [];
        const currentColor = this.gameLogic.getColor();

        let startY = this.boosterNeedlePoint.y;
        if (startY < 0) {
            startY = 0;
        }
        if (startY + rows > this.gameModel.saveTexture.baseTexture.width) {
            startY = this.gameModel.saveTexture.baseTexture.height - rows;
        }

        for (let y = startY; y < startY + rows; y++) {
            for (let x = 0; x < this.gameModel.saveTexture.baseTexture.width; x++) {
                const color = this.gameLogic.getPixelColor(x, y);
                if (color === currentColor) {
                    pixels.push(new Point(x, y));
                    if (!isGreed) {
                        this.gameLogic.fillPixelByBooster(x, y);
                    }
                }
            }
        }

        return pixels;
    }

}
